import React from 'react';
import { Avatar as MuiAvatar } from '@mui/material';
type AvatarProps = {
  name: string;
  sx?: any;
  src?: string;
  variant?: 'circular' | 'rounded' | 'square';
  width?: number;
  height?: number;
};

function Avatar({ name, sx, src, width, height, variant }: AvatarProps) {
  function stringToColor(str: string) {
    let hash = 0;
    let i;
    let color = '#';
    if (src) return color;
    for (i = 0; i < str?.length; i += 1) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
  }

  function stringAvatar(name: string) {
    const trimmedName = name?.trim();
    const nameLength = trimmedName?.split(' ').length || 0;
    if (nameLength === 1) {
      return {
        sx: {
          bgcolor: stringToColor(name),
          width: width || 24,
          height: height || 24,
          ...sx,
        },
        children: `${trimmedName?.split(' ')[0][0]}`,
      };
    } else {
      return {
        sx: {
          bgcolor: stringToColor(name),
          width: width || 24,
          height: height || 24,
          ...sx,
        },
        children: `${trimmedName?.split(' ')[0][0]}${name?.split(' ')[1][0] || ''}`,
      };
    }
  }
  return <MuiAvatar {...stringAvatar(name)} alt={name} src={src} variant={variant} />;
}

export default Avatar;
